import React from "react";
import Link from "gatsby-link";
import styles from "../../static/css/palette.json";

class SiteNav extends React.Component {
  render() {

    return (
      <nav className="navbar" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <Link
            to="/"
            className="navbar-item"
            style={this.props.location.pathname == '/' ? {backgroundColor: styles.colors.P5} : {}}
            >
            <span
              className="title"
              style={this.props.location.pathname == '/' ? {color: styles.colors.P2} : {color: styles.colors.P5}}
              >
              Eng
            </span>
          </Link>
          <Link
            to="/"
            className="navbar-item"
            style={this.props.location.pathname == '/' ? {backgroundColor: styles.colors.P5, color: styles.colors.P2} : {}}
            >
            Home
          </Link>
          <Link
            to="/code-map/"
            className="navbar-item"
            style={this.props.location.pathname == '/code-map/' ? {backgroundColor: styles.colors.P5, color: styles.colors.P2} : {}}
            >
            Code Map
          </Link>
          <Link
            to="/calc/"
            className="navbar-item"
            style={this.props.location.pathname == '/calc/' ? {backgroundColor: styles.colors.P5, color: styles.colors.P2} : {}}
            >
            Calcs
          </Link>
        </div>
      </nav>
    )
  }
}

export default SiteNav;



// WEBPACK FOOTER //
// ./src/components/SiteNav/index.js